export default __webpack_public_path__ + "static/media/icon-node-tipo-exercicio.3efaa423.svg";